import React from 'react';

const CreateTaskModal = ({
    show,
    formData,
    attachmentFiles,
    onClose,
    onSubmit,
    onFormDataChange,
    onAttachmentFilesChange,
    onShowUserSlideOver
}) => {
    if (!show) return null;

    return (
        <div className="modal-overlay create-task-modal" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Create New Task</h2>
                <form onSubmit={onSubmit}>
                    <div className="form-group">
                        <label>Title *</label>
                        <input 
                            type="text" 
                            value={formData.title} 
                            onChange={(e) => onFormDataChange({...formData, title: e.target.value})} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label>Description *</label>
                        <textarea 
                            value={formData.description} 
                            onChange={(e) => onFormDataChange({...formData, description: e.target.value})} 
                            required 
                            rows="4" 
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label>Assign To *</label>
                            <div 
                                className="user-select-trigger"
                                onClick={onShowUserSlideOver}
                            >
                                <span className="user-select-text">
                                    {formData.assignedTo.length === 0 
                                        ? 'Click to select users...' 
                                        : `${formData.assignedTo.length} user(s) selected`
                                    }
                                </span>
                                <span className="user-select-icon">👥</span>
                            </div>
                            {formData.assignedTo.length === 0 && (
                                <small style={{ color: 'red', fontSize: '12px' }}>Please select at least one user</small>
                            )}
                        </div>
                        <div className="form-group">
                            <label>Priority</label>
                            <select 
                                value={formData.priority} 
                                onChange={(e) => onFormDataChange({...formData, priority: e.target.value})}
                            >
                                <option value="low">Low</option>
                                <option value="medium">Medium</option>
                                <option value="high">High</option>
                                <option value="urgent">Urgent</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Due Date *</label>
                        <input 
                            type="date" 
                            value={formData.dueDate} 
                            onChange={(e) => onFormDataChange({...formData, dueDate: e.target.value})} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label>Due Time (optional)</label>
                        <input 
                            type="time" 
                            value={formData.dueTime} 
                            onChange={(e) => onFormDataChange({...formData, dueTime: e.target.value})} 
                            placeholder="Defaults to 23:59 if not set"
                        />
                        <small style={{ color: '#666', fontSize: '0.85em' }}>
                            If not specified, defaults to end of day (23:59)
                        </small>
                    </div>
                    <div className="form-group">
                        <label>Tags (comma separated)</label>
                        <input 
                            type="text" 
                            value={formData.tags} 
                            onChange={(e) => onFormDataChange({...formData, tags: e.target.value})} 
                            placeholder="bug, feature, urgent" 
                        />
                    </div>
                    <div className="form-group">
                        <label>Attachments</label>
                        <input 
                            type="file" 
                            multiple 
                            onChange={(e) => onAttachmentFilesChange(Array.from(e.target.files))} 
                        />
                    </div>
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-secondary">Cancel</button>
                        <button type="submit" className="btn-primary">Create Task</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateTaskModal;
